{
  "Dashboard": "Dashboard",
  "BlyCareShippingProte": "BlyCare Verzendbescherming",
  "LoadingBlyCare": "BlyCare laden…",
  "LoadingWidgetSetting": "Widgetinstellingen laden…",
  "PreparingYourWorkspa": "Je werkruimte voorbereiden",
  "Language": "Taal",
  "English": "English",
  "EnglishDefault": "English (standaard)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Installatiehandleiding",
  "CompletedOfTotalComp": "{{completed}} van {{total}} voltooid",
  "Dismiss": "Sluiten",
  "MoreActions": "Meer acties",
  "ToggleSetupGuide": "Installatiehandleiding in-/uitschakelen",
  "ActivateAppEmbed": "App-embed activeren",
  "ClickTheEnableButton": "1. Klik op de knop Inschakelen hieronder om de thema-editor van Shopify te openen.",
  "BlyCareEmbedSection": "2. Zoek naar BlyCare in het gedeelte App-embed aan de linkerkant. Zorg dat de schakelaar aan staat. Klik vervolgens rechtsboven op Opslaan.",
  "Enable": "Inschakelen",
  "PublishWidget": "Widget publiceren",
  "PublishStorefront": "Publiceer de widget in je webshop, zodat klanten deze kunnen kopen.",
  "Publish": "Publiceren",
  "SetProtectionFee": "Beschermingskosten instellen",
  "FeeYouWantToCharge": "Stel de kosten in die je klanten wilt aanrekenen.",
  "Setup": "Instellen",
  "TestYourWidgetOnYour": "Test je widget in je winkel",
  "AddAProductToYourCar": "Voeg een product toe aan je winkelwagen en controleer of de widget voor verzendbescherming verschijnt. Selecteer verzendbescherming, ga verder naar afrekenen en controleer of het product voor verzendbescherming op de afrekenpagina staat.",
  "TestNow": "Nu testen",
  "Working": "Alles werkt",
  "NeedHelp": "Hulp nodig",
  "MarkAsCompleted": "Markeren als voltooid",
  "AppStatus": "App-status",
  "AppEmbed": "App-embed",
  "EnableAppEmbedToDisp": "Schakel app-embed in om verzendbescherming in de winkelwagen weer te geven.",
  "CartPage": "Verzendbescherming weergeven op de winkelwagenpagina.",
  "CheckoutBlock": "Afrekenblok",
  "CheckoutPage": "Verzendbescherming weergeven op de afrekenpagina.",
  "Active": "Actief",
  "Inactive": "Inactief",
  "Analytics": "Analyses",
  "Today": "Vandaag",
  "Last7Days": "Afgelopen 7 dagen",
  "Last30Days": "Afgelopen 30 dagen",
  "Last60Days": "Afgelopen 60 dagen",
  "Last90Days": "Afgelopen 90 dagen",
  "Last365Days": "Afgelopen 365 dagen",
  "Custom": "Aangepast",
  "Start": "Start",
  "End": "Einde",
  "DateRange": "Datumbereik",
  "SelectedRange": "Geselecteerd bereik: {{range}}",
  "Cancel": "Annuleren",
  "Save": "Opslaan",
  "ChooseAStartDateOnOr": "Kies een startdatum op of vóór de einddatum en kies geen dag na vandaag.",
  "PreviousMonth": "Vorige maand",
  "NextMonth": "Volgende maand",
  "ProtectionRevenue": "Opbrengst bescherming",
  "ProtectedOrders": "Beschermde bestellingen",
  "ProtectedOrderRate": "Percentage beschermde bestellingen",
  "LoadingAnalytics": "Analyses laden…",
  "AnalyticsCouldNotLo": "Analyses konden niet worden geladen",
  "RetryAnalytics": "Analyses opnieuw proberen",
  "Resources": "Bronnen",
  "HowDoesShippingProte": "Hoe werkt verzendbescherming?",
  "BlyCareAddsAShipping": "BlyCare voegt een widget voor verzendbescherming toe aan je winkelwagen. Klanten kunnen ervoor kiezen bescherming aan hun bestellingen toe te voegen. De winkelier int de beschermingskosten, bepaalt welke situaties worden gedekt en gebruikt die kosten om claims af te handelen.",
  "DoesBlyCareCoverInsu": "Dekt BlyCare verzekeringsclaims?",
  "NoBlyCareIsNotInsura": "Nee. BlyCare is geen verzekering en betaalt geen claims uit. BlyCare biedt alleen de widget en hulpmiddelen waarmee winkeliers hun eigen programma voor verzendbescherming beheren.",
  "EmailUs": "E-mail ons",
  "LiveChat": "Livechat",
  "HelpCenter": "Helpcentrum",
  "Settings": "Instellingen",
  "CheckoutWidget": "Afrekenwidget",
  "CartWidget": "Winkelwagenwidget",
  "PriceSetting": "Prijsinstelling",
  "ProductSetting": "Productinstelling",
  "AdminLanguage": "Beheerderstaal",
  "AdminLanguageTitle": "Beheerderstaal",
  "AdminLanguageHelp": "Wijzigt de app-taal alleen voor jou. Klanten merken hier niets van.",
  "AppLanguage": "App-taal",
  "UnableToLoadSettings": "Instellingen kunnen niet worden geladen",
  "TryAgain": "Opnieuw proberen",
  "Discard": "Verwerpen",
  "LoadingSettings": "Instellingen laden",
  "PageNotFound": "Pagina niet gevonden",
  "ProductSettingsCould": "Productinstellingen konden niet worden opgeslagen.",
  "Fulfillment": "Verwerking",
  "FulfillmentHelp": "Kies wanneer het beschermingsproduct als verwerkt wordt gemarkeerd.",
  "ManuallyFulfill": "Handmatig verwerken",
  "MarkFulfilledWhenFir": "Markeer als verwerkt wanneer het eerste artikel in de bestelling is verwerkt",
  "MarkFulfilledWhenAll": "Markeer als verwerkt wanneer alle andere artikelen in de bestelling zijn verwerkt",
  "MarkFulfilledImmedi": "Markeer direct na het aanmaken van de bestelling als verwerkt",
  "Exclusions": "Uitsluitingen",
  "ExclusionsHelp": "Kies wanneer bescherming niet van toepassing is.",
  "ExclusionType": "Type uitsluiting",
  "Select": "Selecteren",
  "SelectedExclusions": "Geselecteerde uitsluitingen",
  "RemoveName": "{{name}} verwijderen",
  "WhenExcluded": "Bij uitsluiting",
  "HideWidget": "Widget verbergen",
  "KeepWidgetButSkipThe": "Widget behouden maar de kosten overslaan",
  "ExcludeProductType": "Producttype uitsluiten",
  "SearchProductType": "Producttype zoeken",
  "ExcludeSKU": "SKU uitsluiten",
  "SearchSKU": "SKU zoeken",
  "ExcludeCollection": "Collectie uitsluiten",
  "SearchCollection": "Collectie zoeken",
  "ExcludeMarket": "Markt uitsluiten",
  "SearchMarket": "Markt zoeken",
  "ExcludeLanguage": "Taal uitsluiten",
  "SearchLanguage": "Taal zoeken",
  "Add": "Toevoegen",
  "PriceSettingsCouldNo": "Prijsinstellingen konden niet worden opgeslagen.",
  "ShippingProtectionPr": "Prijs van verzendbescherming",
  "SetHowMuchPriceDoYou": "Stel in hoeveel je je klant in rekening brengt",
  "PricingMethod": "Prijsmethode",
  "Fixed": "Vast",
  "Percentage": "Percentage",
  "UniversalProtectionP": "Universele beschermingsprijs",
  "PercentageOfCartSubt": "Percentage van het winkelwagensubtotaal",
  "EditCappedPrice": "Maximumprijs bewerken",
  "ShippingProtectionFe": "Kosten voor verzendbescherming op basis van een percentage vanaf {{minPrice}} USD, oplopend met {{increment}} USD, gemaximeerd op {{capped}} USD.",
  "MinProtectionFee": "Minimale beschermingskosten",
  "IncrementAmount": "Verhogingsbedrag",
  "CappedProtectionFee": "Maximale beschermingskosten",
  "AddTierPrice": "Staffelprijs toevoegen",
  "AddTier": "Staffel toevoegen",
  "TierPriceHelp": "Als de winkelwagenprijs niet binnen een van je staffelprijsbereiken valt, geldt de universele prijs die je op de vorige pagina hebt ingesteld.",
  "MinCartPrice": "Minimale winkelwagenprijs",
  "MaxCartPrice": "Maximale winkelwagenprijs",
  "ProtectionFee": "Beschermingskosten",
  "RemoveTier": "Staffel verwijderen",
  "Required": "Verplicht",
  "ThisFieldIsRequired": "Dit veld is verplicht.",
  "MustBeGreaterThanZero": "{{label}} moet groter zijn dan 0.",
  "MustBeOrLess": "{{label}} moet {{max}} of lager zijn.",
  "AtMostTwoDecimals": "{{label}} mag maximaal 2 decimalen hebben.",
  "MustBeLargerThanMinC": "Moet groter zijn dan de minimale winkelwagenprijs",
  "MustBeLargerThanMaxC": "Moet groter zijn dan de maximale winkelwagenprijs",
  "MustBeSmallerThanMin": "Moet kleiner zijn dan de minimale winkelwagenprijs",
  "Price": "Prijs",
  "MinimumPrice": "Minimumprijs",
  "Increment": "Verhoging",
  "CartPageWidget": "Widget op winkelwagenpagina",
  "CheckoutPageWidget": "Widget op afrekenpagina",
  "WidgetFormat": "Widgetformaat",
  "TickerWidget": "Standaardwidget",
  "CheckoutButtonWidget": "Afrekenknopwidget",
  "Text": "Tekst",
  "MainText": "Hoofdtekst",
  "Title": "Titel",
  "Description": "Beschrijving",
  "MainButtonText": "Tekst van hoofdknop",
  "SecondaryButtonText": "Tekst van secundaire knop",
  "EnabledDescription": "Beschrijving bij ingeschakeld",
  "DisabledDescription": "Beschrijving bij uitgeschakeld",
  "PleaseEnterTitle": "Voer een titel in",
  "PleaseEnterDescript": "Voer een beschrijving in",
  "PleaseEnterMainButt": "Voer de tekst van de hoofdknop in",
  "PleaseEnterSecondar": "Voer de tekst van de secundaire knop in",
  "PleaseEnterEnabledD": "Voer de beschrijving bij ingeschakeld in",
  "PleaseEnterDisabled": "Voer de beschrijving bij uitgeschakeld in",
  "EGViewTerms": "bijv. Voorwaarden bekijken",
  "EGHttpTerms": "bijv. https://terms.com",
  "Footer": "Voettekst",
  "FooterText": "Tekst voettekst",
  "FooterLink": "Voettekstlink",
  "TooltipLink": "Tooltiplink",
  "FooterVisibility": "Zichtbaarheid voettekst",
  "TitleInfoVisibility": "Zichtbaarheid titelinformatie",
  "Disabled": "Uitgeschakeld",
  "Enabled": "Ingeschakeld",
  "Color": "Kleur",
  "ColorStyle": "Kleurstijl",
  "SizeAndDisplay": "Grootte en weergave",
  "IconSize": "Pictogramgrootte",
  "IconRadius": "Pictogramhoek",
  "BorderSize": "Randdikte",
  "BorderRadius": "Randafronding",
  "HorizontalPadding": "Horizontale opvulling",
  "VerticalPadding": "Verticale opvulling",
  "ToggleFormat": "Schakelaarformaat",
  "Switch": "Schakelaar",
  "Checkbox": "Selectievakje",
  "Border": "Rand",
  "Background": "Achtergrond",
  "ProtectionDescript": "Beschrijving bescherming",
  "MainButtonBackgrou": "Achtergrond hoofdknop",
  "EnabledToggle": "Schakelaar ingeschakeld",
  "DisabledToggle": "Schakelaar uitgeschakeld",
  "Automatic": "Automatisch",
  "Neutral": "Neutraal",
  "Info": "Info",
  "Success": "Succes",
  "Warning": "Waarschuwing",
  "Critical": "Kritiek",
  "Subdued": "Gedempt",
  "Transparent": "Transparant",
  "ThemeColor": "Themakleur",
  "ResetToDefaultColor": "{{label}}: terugzetten naar de standaardkleur",
  "OpenColorPicker": "{{label}}: kleurkiezer openen",
  "Icon": "Pictogram",
  "PackageIcon": "Pakketpictogram",
  "PackageIconNumber": "Pakketpictogram {{value}}",
  "UploadIcon": "Pictogram uploaden",
  "NoIcon": "Geen pictogram",
  "AcceptedFormats": "Geaccepteerde formaten: PNG, JPG, SVG",
  "MaximumFileSize": "Maximale bestandsgrootte: 50 MB",
  "AddFiles": "Bestanden toevoegen",
  "RemoveImage": "Afbeelding verwijderen",
  "Uploading": "Uploaden",
  "UploadFailedTryAgain": "Uploaden mislukt. Probeer het opnieuw.",
  "ChooseAJPEGPNG": "Kies een JPEG-, PNG- of SVG-afbeelding van maximaal 50 MB.",
  "ChooseNonemptyImage": "Kies een niet-lege JPEG-, JPG-, PNG- of SVG-afbeelding van maximaal 50 MB.",
  "ImageCouldNotBeRead": "De afbeelding kan niet worden gelezen.",
  "FileContentsMismatch": "De bestandsinhoud moet overeenkomen met het afbeeldingstype JPEG, PNG of SVG.",
  "ImageCouldNotBeDecode": "De afbeelding kan niet worden gedecodeerd.",
  "InvalidImageUrl": "De uploadservice heeft een ongeldige afbeeldings-URL geretourneerd.",
  "MissingPublicImageUrl": "De uploadservice heeft geen openbare afbeeldings-URL geretourneerd.",
  "CustomCssTooLong": "Aangepaste CSS mag maximaal 2.000 tekens bevatten.",
  "ChooseValidIconUrl": "Kies een geüpload pictogram met een geldige URL.",
  "EnterNumberRange": "Voer een getal in van {{min}} tot {{max}}.",
  "EnterLocaleTextRange": "Voer {{locale}}-tekst in van 1 tot {{limit}} tekens.",
  "EnterValidLearnMoreUrl": "Voer een geldige URL voor Meer informatie in die begint met https:// of http://.",
  "ReviewHighlightedFields": "Controleer de gemarkeerde velden.",
  "CannotChangePublishState": "De publicatiestatus kan pas worden gewijzigd als het formulier geldig is: {{reason}}",
  "BlyCareCouldNotSave": "BlyCare kon niet opslaan.",
  "CheckoutRequiresPlus": "Het aanpassen van het afrekenproces vereist Shopify Plus.",
  "SaveSucceededReloadFailed": "Het opslaan is gelukt, maar de nieuwste widgetinstellingen konden niet worden geladen. Vernieuw de pagina om je wijzigingen te controleren.",
  "BlyCareCouldNotComplete": "BlyCare kon dit verzoek niet voltooien.",
  "ShopifyAuthorizationRequired": "Shopify-autorisatie is vereist.",
  "AppBridgeUnavailable": "Shopify App Bridge is niet beschikbaar",
  "ExtensionStatusUnavailable": "De status van de Shopify-extensie is niet beschikbaar.",
  "ConfigurationPreview": "Configuratievoorbeeld",
  "On": "Aan",
  "Off": "Uit",
  "Unpublish": "Publicatie ongedaan maken",
  "AppEmbedIsNotEnable": "App-embed is niet ingeschakeld.",
  "GoEnabled": "Ga naar inschakelen",
  "ViewOnYourStorefront": "Bekijk in je webshop",
  "PreviewProtection": "Bescherming bekijken",
  "MoreInformation": "Meer informatie",
  "Cart": "Winkelwagen",
  "Subtotal": "Subtotaal",
  "Checkout": "Afrekenen",
  "DiscountCode": "Kortingscode",
  "Apply": "Toepassen",
  "Shipping": "Verzending",
  "Total": "Totaal",
  "ShippingProtection": "Verzendbescherming",
  "Product": "Product",
  "CopyLink": "Link kopiëren"
}
